import { DS } from '../../../design-system'
import DividerGradient from '../../../assets/divider-gradient.svg'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { CancellationSurveyEnum } from '../cancellation-survey.enum'
import { Dispatch, FC, SetStateAction } from 'react'
import { StyleSheet, TextInput } from 'react-native'

const isNotEnoughFeat = 7
const isOtherReason = 8

interface Step1Props {
  setReason: Dispatch<SetStateAction<string>>
  reason: string
  inputFocus: boolean
  handleFocus: () => void
  setInputFocus: Dispatch<SetStateAction<boolean>>
  setFeedback: Dispatch<SetStateAction<string | undefined>>
}

const CancellationSurveyStep1: FC<Step1Props> = ({
  setReason,
  reason,
  inputFocus,
  handleFocus,
  setFeedback,
  setInputFocus
}) => {
  return (
    <DS.Frame style={styles.surveyContainer}>
      <DS.Frame style={styles.headerNumber}>
        <DividerGradient width={40} style={{ transform: [{ rotate: '180deg' }] }} />
        <DS.Text variant="Mini/Bold">01</DS.Text>
        <DividerGradient width={40} />
      </DS.Frame>

      <DS.Text style={styles.title} variant="Heading 5/Regular">
        Why are you cancelling your membership?
      </DS.Text>

      <DS.Frame style={[styles.checkContainer, { marginBottom: inputFocus ? 30 : 0 }]}>
        {CancellationSurveyEnum.map((item) => (
          <DS.Frame style={styles.checkButtonContainer} key={item.id}>
            <TouchableOpacity key={item.id} style={styles.checkButton} onPress={() => setReason(item.reason)}>
              <DS.Icon name={item.reason === reason ? 'Radio' : 'Radio-uncheck'} size={24} color="Global/Black" />
              <DS.Frame style={styles.optionFrame}>
                <DS.Text variant="Body Small/Regular">{item.reason}</DS.Text>
              </DS.Frame>
            </TouchableOpacity>

            {(item.id === isNotEnoughFeat || item.id === isOtherReason) && item.reason === reason && (
              <DS.Frame style={styles.inputContainer}>
                <TextInput
                  style={styles.input}
                  onFocus={handleFocus}
                  onBlur={() => setInputFocus(false)}
                  onChangeText={(value) => setFeedback(value)}
                />
              </DS.Frame>
            )}
          </DS.Frame>
        ))}
      </DS.Frame>
    </DS.Frame>
  )
}

const styles = StyleSheet.create({
  headerNumber: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginVertical: 8,
    gap: 8
  },
  surveyContainer: {
    flexGrow: 1,
    backgroundColor: `${DS.palette['Global/White']}80`,
    padding: 24,
    marginHorizontal: 24,
    borderRadius: 12
  },
  title: {
    textAlign: 'center',
    paddingBottom: 12
  },
  checkButton: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: DS.palette['Global/White'],
    gap: 12
  },
  checkContainer: {
    gap: 4
  },

  checkButtonContainer: {
    backgroundColor: DS.palette['Global/White'],
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
    gap: 12
  },
  optionFrame: {
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'center'
  },
  buttonContainer: {
    position: 'relative',
    marginTop: 'auto',
    width: '100%',
    marginBottom: 16,
    paddingHorizontal: 24
  },
  inputContainer: {
    backgroundColor: DS.palette['Global/White'],
    justifyContent: 'flex-end',
    paddingLeft: 32
  },
  input: {
    height: 41,
    borderColor: DS.palette['Global/Black'],
    borderWidth: 1,
    borderRadius: 8
  }
})

export default CancellationSurveyStep1
